const Arrow = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.20214 7.20995C9.51318 6.93002 10.0108 6.93002 10.3219 7.20995L14.8009 11.5023C15.0808 11.8134 15.0808 12.311 14.8009 12.591L10.3219 16.79C10.0109 17.07 9.51318 17.07 9.20214 16.79C8.9222 16.479 8.9222 15.9813 9.20214 15.6703L13.1835 12L9.20214 8.3297C8.9222 8.01866 8.9222 7.521 9.20214 7.20995Z"
        fill="#1A1919"
      />
    </svg>
  );
};

export default Arrow;
